// extracted by mini-css-extract-plugin
module.exports = {"shopSearchPlace":"Search_shopSearchPlace__ip_uC","shopSearch":"Search_shopSearch__KQpsY","open":"Search_open__LkY9_"};